module.exports = __webpack_public_path__ + "img/upload_info_m_png.72448875.svg";